'use strict';

/* global $ */

import { Ajax } from '../utils/ajax';
import { ajax } from 'settings';
import { Geo } from '../modules/geo';
import { Modal } from '../modules/modal';

function City(options) {

    let opt = $.extend({
        current: options.selector + '__current',
        currentFull: options.selector + '__current-full',
        confirm: options.selector + '__confirm',
        confirmItem: options.selector + '__confirm-item',
        input: options.selector + '__input',
        list: options.selector + '__list',
        item: options.selector + '__list-item',
        modal: options.selector + '__modal'
    }, options);

    let geo = new Geo({selector: '.js-location'});
    let modal = new Modal({selector: opt.modal})

    function initBlock(el) {
        console.log('[ City/Init ]');
        let $el = $(el);
        let $list = $el.find(opt.list);


        $el.find(opt.current).on('click', function(e) {
            e.preventDefault();
            console.log('[ City/Show select city ]');
            $el.find(opt.confirm).removeClass('is-open');
            modal.showModal();
            initLocalitieList(el);
        });
        $el.find(opt.confirmItem).on('click', function(e) {
            e.preventDefault();
            console.log('[ City/Click confirm item ]');
            let confirm = +$(this).data('confirm');
            $el.attr('data-confirmed', confirm);
            $el.find(opt.confirm).removeClass('is-open');
            if (confirm === 0) {
                modal.showModal();
                initLocalitieList(el);
            } else {
                geo.setConfirmLocation();
            }
        });

        if (+$el.attr('data-confirmed') === 0) {
            $el.find(opt.confirm).addClass('is-open');
        }

        $el.find(opt.input).on('input', function() {
            console.log('[ City/Change search string ]');
            let str = $(this).val();
            console.log(str, str.length);
            if (str.length > 1) {
                $list.find(opt.item).removeClass('is-hidden');
                $list.find(opt.item).filter(function() {
                    return $(this).data('localitie').toLowerCase().indexOf(str.toLowerCase()) === -1; // && $(this).data('area').toLowerCase().indexOf(str.toLowerCase()) === -1;
                }).addClass('is-hidden');
            } else {
                $list.find(opt.item).removeClass('is-hidden');
            }
        });

        function initLocalitieList(el) {
            let $el = $(el);
            let $list = $el.find(opt.list);

            if (!$list.find(opt.item).length) {
                $list.append(ajax.loader);
                Ajax.get('get_city_list', {}).then((data) => {
                    if (data.ok) {
                        console.log(data);
                        if (data.city_list) {
                            let content = '';
                            data.city_list.forEach(item => {
                                const itemHTML = 
                                    '<a href="#" class="header__city-item js-city__list-item" data-area="' + item.area + '" data-localitie="' + item.localitie + '">' +
                                    item.localitie_name +
                                    '</a>';
                                content += itemHTML;
                            });
                            $list.html(content);

                            $list.find(opt.item).on('click', function(e) {
                                e.preventDefault();
                                $list.find(opt.item).removeClass('is-active');
                                $(this).addClass('is-active');
                                let localitie = $(this).data('localitie') ? [$(this).data('localitie')] : [];
                                let area = $(this).data('area') ? [$(this).data('area')] : [];
                                $el.find(opt.current).text(localitie[0]);
                                $el.find(opt.currentFull).text(localitie[0] + (area[0] ? ', ' + area[0] : ''));
                                geo.setLocation('.js-player', area, localitie);
                                geo.setConfirmLocation();
                                modal.closeModal();
                            });
                        }
                    } else {
                        console.error('Can\'t set location');
                    }
                }).catch(function(error) {
                    throw new Error(error);
                });
            }
        }
    }

    $(opt.selector).each(function() {
        initBlock(this);
    });
}

export {
    City
};
